import * as Yup from "yup";

export type topic = {
  global_name: string;
  status: string;
};

export const topicInitialValues: topic = {
  global_name: "",
  status: "",
};

export const topicMandatoryFields = [
  { id: "global_name" },
  { id: "status" },
];

export const topicValidationSchema = Yup.object().shape({
});

export const topicProperties = [
  {
    id: "global_name",
    type: "text",
    label: `Name`,
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
    {
    id: "status",
    type: "normal-select",
    label: "Status",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "Active", value: "ACTIVE" },
      { label: "InActive", value: "INACTIVE" },
      { label: "Deleted", value: "DELETED" },
    ],
    hideNone: true,
  },
];

export function hasAtLeastOneValue(obj, keys) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0)
    );
  });
}

